import { render, staticRenderFns } from "./SecurityServer.vue?vue&type=template&id=774e71ca&"
import script from "./SecurityServer.vue?vue&type=script&lang=ts&"
export * from "./SecurityServer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports